/**
 * GET DEPARTMENT
 */
import * as _ from 'lodash-es';
import { Dispatch } from 'redux';

import {
  ACTION_GET_DEPARTMENT,
  ACTION_GET_DEPARTMENT_SUCCESS,
  ACTION_GET_DEPARTMENT_FAILURE,
  ACTION_RESET_GET_DEPARTMENT_SUCCESS,
  API_CALL,
} from '../../configs/ActionTypes';
import { enqueueSnackbarHandler } from '../Status';

export function getDepartments(name: string, organizationId: string) {
  return (dispatch: Dispatch, getState: Function) => {
    dispatch(requestStarted());

    dispatch({
      type: API_CALL,
      payload: {
        call: `organizations/${organizationId}/department`,
        method: 'get',
        data: { name: name },
        success: (response: object) => {
          dispatch(requestSuccess(response));
        },
        fail: (error: any) => {
          _.get(error.payload, 'userPermissionError', false)
            ? enqueueSnackbarHandler(dispatch, error.payload, 'error')
            : enqueueSnackbarHandler(
                dispatch,
                { getDepartmentFailed: true },
                'error',
              );
          dispatch(requestFailed());
        },
      },
    });

    return null;
  };
}

export function requestStarted() {
  return {
    type: ACTION_GET_DEPARTMENT,
    payload: null,
  };
}

export function resetGetDepartments() {
  return (dispatch: Dispatch, getState: Function) => {
    // Dispatch the api call request.
    dispatch({
      type: ACTION_RESET_GET_DEPARTMENT_SUCCESS,
      payload: null,
    });
  };
}

function requestSuccess(responeJSON: object) {
  return {
    type: ACTION_GET_DEPARTMENT_SUCCESS,
    payload: responeJSON,
  };
}

function requestFailed() {
  return {
    type: ACTION_GET_DEPARTMENT_FAILURE,
    payload: null,
  };
}
